import { Provider } from '@angular/core';

import { ApiTokenProvider } from '@customer-portal/api';
import { AuthenticationStore } from '@customer-portal/ciam';

/**
 * Bridges {@link ApiTokenProvider} to {@link AuthenticationStore}
 * so the API interceptor can obtain tokens without a direct dependency on CIAM.
 */
export function provideApiToken(): Provider {
  return { provide: ApiTokenProvider, useExisting: AuthenticationStore };
}
